import { SortingFn } from "@tanstack/react-table";
import i18next from "i18next";

import { IArticlesTableContent } from "../../../../@types/Articles";
import { createColumn } from "../../../../components/Table";
import { getWardLabel } from "../../../../utils/wardLabel";

// Case-insensitive, locale-aware text sort (same approach as the patient list
// name column). Without it, TanStack auto-detects `alphanumeric` for columns
// whose values contain digits (e.g. "Test link 3 111111"), which jumbles the
// A-Z order. Trims first so a stray leading/trailing space doesn't push a row
// out of order. Sorts on the raw row value, not the rendered cell.
const sortByText =
  (key: "title" | "author" | "wards"): SortingFn<IArticlesTableContent> =>
  (rowA, rowB) =>
    (rowA.original[key] ?? "")
      .trim()
      .localeCompare((rowB.original[key] ?? "").trim());

export const articlesListColumns = [
  createColumn<IArticlesTableContent>({
    keyName: "title",
    header: () => i18next.t("careInfo_columns_title"),
    cell: (info) => info.renderValue(),
    size: 300,
    sortingFn: sortByText("title"),
  }),
  // createColumn({
  //   keyName: "cardImage",
  //   header: () => "Card image",
  //   cell: (info) => info.renderValue(),
  // }),
  createColumn({
    keyName: "numberOfReads",
    header: () => i18next.t("careInfo_columns_reads"),
    cell: (info) => info.renderValue(),
    size: 120,
  }),
  // createColumn({
  //   keyName: "tags",
  //   header: () => "Tags",
  //   cell: (info) => info.renderValue(),
  // }),
  createColumn<IArticlesTableContent>({
    keyName: "lastEdited",
    header: () => i18next.t("careInfo_columns_lastEdited"),
    cell: (info) => info.renderValue(),
    // Sort on the raw ISO date (lastEditedRaw), not the formatted display
    // string, so ordering is chronological rather than alphabetical.
    sortingFn: (rowA, rowB) => {
      const a = rowA.original.lastEditedRaw
        ? new Date(rowA.original.lastEditedRaw).getTime()
        : 0;
      const b = rowB.original.lastEditedRaw
        ? new Date(rowB.original.lastEditedRaw).getTime()
        : 0;
      return a - b;
    },
  }),
  createColumn<IArticlesTableContent>({
    keyName: "author",
    header: () => i18next.t("careInfo_columns_author"),
    cell: (info) => info.renderValue(),
    size: 150,
    sortingFn: sortByText("author"),
  }),
  createColumn<IArticlesTableContent>({
    keyName: "wards",
    header: () => getWardLabel().plural,
    cell: (info) => info.renderValue(),
    size: 200,
    sortingFn: sortByText("wards"),
  }),
  createColumn({
    keyName: "published",
    header: () => i18next.t("careInfo_columns_published"),
    cell: (info) => info.renderValue(),
    size: 50,
    // Rendered as an icon element, so there's no meaningful sort order.
    enableSorting: false,
  }),
];
